import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import BaseDialog from '../BaseDialog';

const PlannedRoundDecisionDialog = ({
  isVisible,
  plannedRoundCount,
  onCheckout,
  onContinue,
  dialogMode,
  containerRef,
}) => (
  <BaseDialog
    isVisible={isVisible}
    onClose={() => {}}
    maxWidth="min(92vw, 440px)"
    clickOutsideToClose={false}
    dialogMode={dialogMode}
    containerRef={containerRef}
  >
    <Box sx={{ width: 380, maxWidth: '100%', p: 1 }}>
      <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>
        予定していた{plannedRoundCount}ラウンドが終了しました
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 700 }}>
        このルームを終了しますか？
      </Typography>
      <Typography variant="body2" sx={{ color: '#64748b', mt: 1.25, mb: 2 }}>
        続けて次のラウンドを開催することもできます。
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end">
        <Button variant="outlined" onClick={onContinue}>
          次のラウンドを開催する
        </Button>
        <Button color="error" variant="contained" onClick={onCheckout}>
          ルームを終了する
        </Button>
      </Stack>
    </Box>
  </BaseDialog>
);

export default PlannedRoundDecisionDialog;
